import cn from "classnames";
import RouteModal from "components/modal/routeSegments";
import Loader from "components/shared/loader";
import { dateToView } from "helpers/date";
import { gasStationTypesEnum, mapObjectTypes, mapObjectTypesEnum } from "helpers/enums";
import { enumLabel } from "helpers/system";
import React from "react";
import { CustomScroll } from "react-custom-scroll";
import SkippedRefuelingsMap from "./map";

class SkippedRefuelings extends RouteModal {
    initialState = {
        viewport: {
            zoom: 6,
            center: [55.7473, 52.4568],
        },
    };

    componentDidMount() {
        this.setState({ ...this.initialState, isLoading: false });
    }

    renderBody = () => {
        const { isLoading } = this.state;
        return isLoading ? (
            <Loader />
        ) : (
            <div className="map-panels">
                <div className="map-panels__content">
                    <CustomScroll heightRelativeToParent="100%">
                        {this.props.skippedRefuelings.map(this.renderItem)}
                    </CustomScroll>
                </div>
            </div>
        );
    };

    renderFuelIcon = (item) => {
        const { resource, gasStationType } = item;
        const className = cn("map-panel__refueling-icon", {
            "map-panel__refueling-icon--default":
                (!resource || !resource.iconUrl) && (!gasStationType || gasStationType === gasStationTypesEnum.Unknown),
        });

        let icon;
        if (resource && resource.iconUrl) {
            icon = (
                <img
                    src={resource.iconUrl}
                    className="b-timeline-point__circle--route-refueling-logo"
                    alt={resource.name || ""}
                />
            );
        } else if (gasStationType === gasStationTypesEnum.Rosneft) {
            icon = (
                <img
                    src="/images/refuelings/rosneft.png"
                    className="b-timeline-point__circle--route-refueling-logo"
                    alt="Роснефть"
                />
            );
        }

        return <div className={className}>{icon}</div>;
    };

    centerMap = ({ location }) => {
        const { item } = this.props;
        if (location) {
            return this.mergeMapViewport({ center: [...location.coordinates].reverse() });
        }
        return this.mergeMapViewport({ center: [...item.geozone.location.coordinates].reverse() });
    };

    renderItem = (item) => {
        const { mapObject, autoSkippedAt, name, id } = item;
        return (
            <div className="map-panel" key={id}>
                <div className="map-panel__head">
                    {this.renderFuelIcon(item)}
                    <div className="map-panel__head-title">
                        {enumLabel(mapObjectTypes, mapObjectTypesEnum.GasStation)} {name || ""}
                    </div>
                </div>
                <div className="map-panel__point-body">
                    <div className="map-panel__point-address link" onClick={() => this.centerMap(mapObject)}>
                        {mapObject.address || "Показать на карте"}
                    </div>
                    <div className="map-panel__enter-date">{dateToView(autoSkippedAt, "DD.MM.YYYY HH:mm (Z)")}</div>
                </div>
            </div>
        );
    };

    renderMap = () => {
        const { viewport } = this.state;

        if (!viewport) {
            return null;
        }
        return (
            <SkippedRefuelingsMap
                markersWithoutTooltips
                {...this.props}
                viewport={viewport}
                mergeMapViewport={this.mergeMapViewport}
            />
        );
    };
}

export default SkippedRefuelings;
